import { ButtonGroupProps, ButtonProps } from '@mui/material';
import { IFormFieldConfig } from '../../../../shared/components/FormFieldsConstructor';

// types
export type TChildMenuItemPayload = Omit<IChildMenuItemResponse, 'id'>;
export type TAnyItem = IMenuItem | IChildMenuItem;
export type TNullableAnyItem = TAnyItem | null;
export type TMenuItemFormConfig = IFormFieldConfig<IChildMenuItem>[];

// enums
export enum EMenuItemType {
  Expandable = 'Expandable',
  Queue = 'Queue',
  Link = 'Link',
  Header = 'Header',
  Divider = 'Divider',
}

export enum EMenuIcon {
  Adjust = 'adjust',
  Ban = 'ban',
  BarChart = 'bar-chart',
  Bell = 'bell',
  Book = 'book',
  Bullseye = 'bullseye',
  CheckSquareOutlined = 'check-square-o',
  Comments = 'comments',
  Dashboard = 'dashboard',
  Dollar = 'dollar',
  Edit = 'edit',
  Envelope = 'envelope',
  EnvelopeOutlined = 'envelope-o',
  Fire = 'fire',
  Folder = 'folder',
  FolderOpenOutlined = 'folder-open-o',
  Gear = 'gear',
  Gears = 'gears',
  HackerNews = 'hacker-news',
  History = 'history',
  Home = 'home',
  LightbulbOutlined = 'lightbulb-o',
  List = 'list',
  Magic = 'magic',
  Money = 'money',
  PauseCircleOutlined = 'pause-circle-o',
  PlusSquare = 'plus-square',
  PuzzlePiece = 'puzzle-piece',
  Random = 'random',
  Remove = 'remove',
  Send = 'send',
  ShareAltSquare = 'share-alt-square',
  SignOut = 'sign-out',
  StreetView = 'street-view',
  Table = 'table',
  ThList = 'th-list',
  ThumbsUp = 'thumbs-up',
  Tint = 'tint',
  User = 'user',
  Users = 'users',
}

// interfaces
export interface IChildMenuItemResponse {
  id: string;
  text: string | null;
  menuItemType: EMenuItemType;
  link: string | null;
  hasAlert: boolean;
  order: number;
  alertCount: number | null;
  queueId: string | null;
  roleIds: string[];
  iconClass: EMenuIcon | null;
  highlightColor1: string;
  highlightColor2: string;
  isDeleted: boolean;
  disabled?: boolean;
  elementKey?: string | null;
}

export interface IMenuItemResponse extends IChildMenuItemResponse {
  childMenuItems: IChildMenuItemResponse[];
}

export interface IChildMenuItem extends IChildMenuItemResponse {
  parentId: string;
}

export interface IMenuItem extends Omit<IMenuItemResponse, 'childMenuItems'> {
  childMenuItems: IChildMenuItem[];
  parentId: null;
}

export interface IButtonConfig extends ButtonGroupProps {
  buttons: ButtonProps[];
}


export interface IMenuItemIconOption {
  value: EMenuIcon;
  label: EMenuIcon;
}

export interface IMenuItemTypeOption {
  id: EMenuItemType;
  name: string;
}

export interface IMenuValues {
  menuItems: IMenuItem[];
}

export interface IMenuItemPayload extends Omit<IMenuItemResponse, 'id' | 'childMenuItems'> {
  childMenuItems: TChildMenuItemPayload[];
}
